export default "__VITE_ASSET__CIPqYuWF__"